import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./App";
import Login from "./auth/Login";
import Register from "./auth/Register";
import Reset from "./auth/Reset";
import Dashboard from "./Dashboard";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import TempIndex from "./TempIndex";

import { createRoot } from "react-dom/client";
import MoreInfo from "./components/shop/MoreInfo";
import Privacy from "./components/Privacy";
import Info from "./components/Info";
import Privacy_CAR_SERVICE_Data from "./components/Privacy_CAR_SERVICE_Data";
import MotorVelanidiaDraw from "./components/MotorVelanidiaDraw";
import PrivacyVelanidiaFarm from "./components/PrivacyVelanidiaFarm";
import PrivacyEmberShelter from "./components/PrivacyEmberShelter";
// const DATA = [
//   { id: "item-0", name: "pencil" },
//   { id: "item-1", name: "pen" },
//   { id: "item-2", name: "chicken" },
// ];

const root = createRoot(document.getElementById("root"));

// const DATA = [];
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<TempIndex />}></Route>
      {/* <Route path="/register" element={<Register />}></Route> */}
      <Route path="/admin" element={<Login />}></Route>
      <Route path="/software" element={<Info />}></Route>
      <Route path="/more_info" element={<MoreInfo />}></Route>
      <Route path="/privacy" element={<Privacy />}></Route>
      <Route path="/privacy_car_service_data" element={<Privacy_CAR_SERVICE_Data />}></Route>
      <Route path="/privacy_velanidia_farm" element={<PrivacyVelanidiaFarm />}></Route>
      <Route path="/privacy_ember_shelter" element={<PrivacyEmberShelter />}></Route>
      <Route path="/motor" element={<MotorVelanidiaDraw />}></Route>
      {/* <Route path="/" element={<TempIndexPublic />}></Route> */}
      {/* <Route path="/june" element={<June />}></Route>
      <Route path="/july" element={<July />}></Route>
      <Route path="/dashboard" element={<Dashboard />}></Route> */}
    </Routes>
  </BrowserRouter>
);

//  <Routes>
//       <Route path="/" component={Login} />
//     </Routes>
// root.render(
//   <BrowserRouter>
//     <Routes>
//       <Route path="/" element={<App />}>
//         <Route path="expenses" element={<AddForm />} />
//         <Route path="invoices" element={<App />} />
//       </Route>

//       <Route path="Add" element={<AddForm />} />
//       {/* <Route path="invoices" element={<Invoices />} /> */}
//     </Routes>
//   </BrowserRouter>
